import React from "react";
import { T } from "../app/tokens.js";
import "./objectChrome.css";

// Geometry lives in objectChrome.css. Consumers own content, horizontal
// alignment, routing and sticky/scroll placement, not density or typography.
export function ChromeTab({ as: Element = "button", active, className = "", style, ...props }) {
  return <Element {...props} className={`object-chrome-tab ${className}`.trim()}
    data-active={active ? "true" : "false"}
    style={{ ...style, "--object-tab-ink": active ? T.blue : T.mid,
      "--object-tab-accent": T.blue, "--object-tab-hover-bg": T.listChipBg }} />;
}
